import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f0b87e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "belong-bar"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "belong-bar__label"
}, "所属：", -1));
const _hoisted_3 = {
  key: 0,
  class: "belong-bar__chip"
};
const _hoisted_4 = {
  key: 1,
  class: "belong-bar__sep"
};
const _hoisted_5 = {
  key: 2,
  class: "belong-bar__chip belong-bar__chip--module"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-tip"
}, "（首次保存后锁定，不可修改）", -1));
const _hoisted_7 = {
  class: "options-tip__text"
};
const _hoisted_8 = {
  class: "options-tip__num"
};
import { computed, reactive, ref, toRef, watch, onBeforeUnmount } from 'vue';
import { useStore } from '@/store';
import { message } from 'ant-design-vue';
import { AppstoreOutlined, CheckCircleFilled, InfoCircleFilled, LoadingOutlined } from '@ant-design/icons-vue';
import { PARAM_SOURCE_OPTIONS } from '../types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ParamEditModal',
  props: {
    visible: {
      type: Boolean
    },
    param: null,
    moduleId: null,
    moduleName: null,
    columnName: null,
    fetchSourceOptions: null,
    onSubmit: null
  },
  emits: ["update:visible"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /**
     * 参数新增 / 编辑弹窗（共用）
     *
     * 5 个字段：
     *   1) 参数名称（必填，30 字内）
     *   2) 参数编码（必填，首次保存后锁定不可改）
     *   3) 参数来源（必填，5 选 1）
     *   4) 参数值（必填，控件随来源联动）
     *   5) 备注（可选，多行）
     *
     * 关键交互：
     * - 参数来源切换 → 控件自动联动：
     *     CUSTOM_TEXT → 单行 input / 多行 textarea（额外用 radio 切单/多行）
     *     CONTACTS/APP/CHANNEL → 远程下拉多选
     *   切换时旧值会被清空 / 过滤（不匹配新来源的去掉）
     *
     * - 编辑回填：
     *   后端 paramValue 是字符串，枚举型来源时是 JSON 数组字符串；
     *   parseValueForForm() 解析后填到 multiValue（只存 value 字段）
     *
     * - 提交序列化：
     *   buildPayloadValue() 把表单 multiValue 转回后端要的 JSON 结构：
     *     CHANNEL  → ["alipay","wxpay"]
     *     CONTACTS → [{userId,userName,name}]
     *     APP      → [{dbtId,appName}]
     *
     * 校验：
     * - 所有表单错误用内联红字提示（不用 toast）
     * - 提交按钮带 submitting guard + confirm-loading 双重防连点
     */
    const open = computed({
      get: () => props.visible,
      set: v => emit('update:visible', v)
    });
    const isEdit = computed(() => props.param != null);
    /** 编辑态且后端标记为已锁定 → 编码字段禁用 */
    const codeLocked = computed(() => {
      var _props$param$codeLock, _props$param;
      return isEdit.value && ((_props$param$codeLock = (_props$param = props.param) === null || _props$param === void 0 ? void 0 : _props$param.codeLocked) !== null && _props$param$codeLock !== void 0 ? _props$param$codeLock : false);
    });
    const sourceOptions = PARAM_SOURCE_OPTIONS;
    /** 表单数据（不含参数值；值用 textValue / multiValue 分别承载） */
    const form = reactive({
      paramName: '',
      paramCode: '',
      paramSource: 'CUSTOM_TEXT',
      paramValueType: 'TEXT',
      remark: ''
    });
    /** 内联校验错误信息 */
    const errors = reactive({
      paramName: '',
      paramCode: '',
      paramValue: ''
    });
    // 参数值的两种承载形式（按来源类型互斥使用）
    /** CUSTOM_TEXT 时使用：单行 / 多行文本 */
    const textValue = ref('');
    /** 枚举型来源时使用：多选下拉的选中 value 数组 */
    const multiValue = ref([]);
    // 用户编辑时自动清错（替代模板里 @update:value，避免与 v-model:value 冲突报警）
    watch(toRef(form, 'paramName'), () => {
      errors.paramName = '';
    });
    watch(toRef(form, 'paramCode'), () => {
      errors.paramCode = '';
    });
    watch([textValue, multiValue], () => {
      errors.paramValue = '';
    });
    const submitting = ref(false);
    const loadingOptions = ref(false);
    /** 当前来源对应的候选项列表（由 fetchSourceOptions 加载） */
    const currentOptions = ref([]);
    const store = useStore();
    const selectedContacts = ref(new Map());
    const contactCandidates = ref(new Map());
    const searchError = ref('');
    let requestId = 0;
    let searchTimer;
    const resetOptions = () => {
      requestId++;
      clearTimeout(searchTimer);
      currentOptions.value = [];
      contactCandidates.value = new Map();
      loadingOptions.value = false;
      searchError.value = '';
    };
    // 仅用 labelInValue 回显快照；历史人员不注入候选且标签仍可移除。
    const selectValue = computed({
      get: () => form.paramSource === 'CONTACTS' ? multiValue.value.map(id => {
        var _selectedContacts$val, _selectedContacts$val2;
        return {
          value: id,
          label: (_selectedContacts$val = (_selectedContacts$val2 = selectedContacts.value.get(id)) === null || _selectedContacts$val2 === void 0 ? void 0 : _selectedContacts$val2.name) !== null && _selectedContacts$val !== void 0 ? _selectedContacts$val : ''
        };
      }) : multiValue.value,
      set: values => {
        multiValue.value = values.map(item => typeof item === 'string' ? item : String(item.value));
      }
    });
    const syncSelectedContacts = () => {
      if (form.paramSource !== 'CONTACTS') return;
      const selected = new Map();
      multiValue.value = [...new Set(multiValue.value.map(String))];
      multiValue.value.forEach(id => {
        const contact = selectedContacts.value.get(id) || contactCandidates.value.get(id);
        if (contact) selected.set(id, contact);
      });
      selectedContacts.value = selected;
    };
    const searchContacts = value => {
      if (form.paramSource !== 'CONTACTS') return;
      resetOptions();
      const keyword = value.trim();
      if (keyword.length === 1) {
        searchError.value = '请至少输入两个字符';
        return;
      }
      loadingOptions.value = true;
      if (keyword) searchTimer = setTimeout(() => loadOptions('CONTACTS', keyword), 300);else loadOptions('CONTACTS', '');
    };
    watch(() => store.userInfo, () => {
      if (form.paramSource !== 'CONTACTS') return;
      resetOptions();
      selectedContacts.value = new Map();
      multiValue.value = [];
    }, {
      flush: 'sync'
    });
    onBeforeUnmount(resetOptions);
    /** 不同来源的下拉占位文案 */
    const multiSelectPlaceholder = computed(() => {
      switch (form.paramSource) {
        case 'CONTACTS':
          return '请选择通讯录成员（多选）';
        case 'APP':
          return '请选择产品（多选）';
        case 'CHANNEL':
          return '请选择支付渠道（多选）';
        default:
          return '请选择';
      }
    });
    /** 候选项提示状态：loading / empty / count */
    const optionsTipState = computed(() => {
      if (searchError.value) return 'empty';
      if (loadingOptions.value) return 'loading';
      if (!currentOptions.value.length) return 'empty';
      return 'count';
    });
    /** 候选项加载状态 / 数量提示文本（仅 loading / empty 时用；count 单独模板渲染以便加粗数字） */
    const optionsTip = computed(() => {
      if (searchError.value) return searchError.value;
      if (optionsTipState.value === 'loading') return '加载候选项中…';
      if (optionsTipState.value === 'empty') {
        if (form.paramSource === 'CONTACTS') return '未找到人员';
        if (form.paramSource === 'CHANNEL') return '暂无候选项';
        return '该来源的候选项接口暂未接入，待后端提供';
      }
      return '';
    });
    /** 候选项提示的样式 class（按状态切换主题色） */
    const optionsTipClass = computed(() => `options-tip--${optionsTipState.value}`);
    /**
     * 拉取候选项；CUSTOM_TEXT 不需要直接清空
     * 实际请求由 props.fetchSourceOptions 负责；序号隔离旧来源与旧搜索响应
     */
    const loadOptions = async (source, keyword = '') => {
      resetOptions();
      if (source === 'CUSTOM_TEXT') return;
      const id = requestId;
      loadingOptions.value = true;
      try {
        const options = source === 'CONTACTS' ? await props.fetchSourceOptions(source, keyword) : await props.fetchSourceOptions(source);
        if (id !== requestId) return;
        if (source === 'CONTACTS') {
          const contacts = new Map();
          const converted = options.map(option => {
            const contact = JSON.parse(option.value);
            const userId = String(contact.userId);
            contacts.set(userId, {
              userId,
              userName: contact.userName,
              name: contact.name
            });
            return {
              value: userId,
              label: option.label
            };
          });
          contactCandidates.value = contacts;
          currentOptions.value = converted;
        } else currentOptions.value = options;
      } catch {
        if (id === requestId) searchError.value = '人员查询失败，请重试';
      } finally {
        if (id === requestId) loadingOptions.value = false;
      }
    };
    /**
     * 来源切换联动
     * - 切到 CUSTOM_TEXT：控件类型保留之前的单/多行选择；清空多选值
     * - 切到枚举型：强制 MULTI_SELECT；清空文本；加载候选项；过滤旧值
     */
    const onSourceChange = async newSource => {
      const wasContacts = selectedContacts.value.size > 0 || contactCandidates.value.size > 0;
      resetOptions();
      const id = requestId;
      selectedContacts.value = new Map();
      if (wasContacts || newSource === 'CONTACTS') multiValue.value = [];
      if (newSource === 'CUSTOM_TEXT') {
        form.paramValueType = form.paramValueType === 'LARGE_TEXT' ? 'LARGE_TEXT' : 'TEXT';
        multiValue.value = [];
      } else {
        form.paramValueType = 'MULTI_SELECT';
        textValue.value = '';
        await loadOptions(newSource);
        if (form.paramSource !== newSource || requestId !== id + 1) return;
        // 旧选项不在新来源候选中的清掉，避免提交无效 value
        const allowed = new Set(currentOptions.value.map(o => o.value));
        multiValue.value = multiValue.value.filter(v => allowed.has(v));
      }
    };
    /**
     * 编辑回填：把后端 paramValue（字符串 / JSON 字符串）解析到 textValue / multiValue
     *
     * - CUSTOM_TEXT：直接填到 textValue
     * - 枚举型：JSON.parse 后取每项的"主键字段"作为 multiValue 的 value
     *   主键字段对照：CONTACTS=userId / APP=dbtId / CHANNEL=直接字符串
     *
     * 解析失败时静默降级（multiValue 置空），避免弹窗崩溃
     */
    const parseValueForForm = p => {
      var _p$paramValue;
      const src = p.paramSource;
      const raw = (_p$paramValue = p.paramValue) !== null && _p$paramValue !== void 0 ? _p$paramValue : '';
      if (src === 'CUSTOM_TEXT') {
        textValue.value = String(raw);
        multiValue.value = [];
        return;
      }
      textValue.value = '';
      try {
        const arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!Array.isArray(arr)) {
          multiValue.value = [];
          return;
        }
        multiValue.value = arr.map(item => {
          var _obj$dbtId;
          // CHANNEL 是字符串数组，其它是对象数组
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object') {
            const obj = item;
            switch (src) {
              case 'CONTACTS':
                {
                  var _obj$userId;
                  const id = String((_obj$userId = obj.userId) !== null && _obj$userId !== void 0 ? _obj$userId : '');
                  if (id) selectedContacts.value.set(id, {
                    ...obj,
                    userId: id
                  });
                  return id;
                }
              case 'APP':
                return String((_obj$dbtId = obj.dbtId) !== null && _obj$dbtId !== void 0 ? _obj$dbtId : '');
              default:
                return '';
            }
          }
          return '';
        }).filter(Boolean);
        if (src === 'CONTACTS') multiValue.value = [...new Set(multiValue.value)];
      } catch {
        multiValue.value = [];
      }
    };
    /**
     * 提交序列化：把表单的 textValue / multiValue 转回后端要求的 paramValue（字符串）
     *
     * 不同来源对应不同结构（后端按 paramSource 校验解析）：
     * - CUSTOM_TEXT：原始字符串
     * - CHANNEL：字符串数组 JSON，如 ["alipay","wxpay"]
     * - CONTACTS：[{userId, userName, name}] JSON
     * - APP：[{dbtId, appName}] JSON
     *
     * CONTACTS 使用已选快照，保留历史缺失字段和新选项的姓名账号。
     */
    const buildPayloadValue = () => {
      const src = form.paramSource;
      if (src === 'CUSTOM_TEXT') return textValue.value;
      if (src === 'CHANNEL') {
        return JSON.stringify(multiValue.value);
      }
      if (src === 'CONTACTS') return JSON.stringify(multiValue.value.map(id => selectedContacts.value.get(String(id))));
      // APP：从候选项映射拿 label，按对应结构序列化
      const optMap = new Map(currentOptions.value.map(o => [o.value, o.label]));
      const items = multiValue.value.map(v => {
        var _optMap$get;
        const label = (_optMap$get = optMap.get(v)) !== null && _optMap$get !== void 0 ? _optMap$get : '';
        switch (src) {
          case 'APP':
            return {
              dbtId: v,
              appName: label
            };
          default:
            return {
              value: v,
              label
            };
        }
      });
      return JSON.stringify(items);
    };
    // 弹窗打开时初始化表单
    watch(() => props.visible, async v => {
      resetOptions();
      selectedContacts.value = new Map();
      if (!v) {
        multiValue.value = [];
        return;
      }
      if (props.param) {
        // 编辑：用现有 param 字段回填，并解析 paramValue
        form.paramName = props.param.paramName || '';
        form.paramCode = props.param.paramCode || '';
        form.paramSource = props.param.paramSource || 'CUSTOM_TEXT';
        // 后端可能不传 paramValueType；按 paramSource 推断默认值
        form.paramValueType = props.param.paramValueType || (form.paramSource === 'CUSTOM_TEXT' ? 'TEXT' : 'MULTI_SELECT');
        form.remark = props.param.remark || '';
        parseValueForForm(props.param);
      } else {
        // 新增：表单全部初始化为默认
        form.paramName = '';
        form.paramCode = '';
        form.paramSource = 'CUSTOM_TEXT';
        form.paramValueType = 'TEXT';
        form.remark = '';
        textValue.value = '';
        multiValue.value = [];
      }
      // 清空所有错误态
      errors.paramName = '';
      errors.paramCode = '';
      errors.paramValue = '';
      // 枚举型来源需要立即加载候选项，确保下拉可用
      if (form.paramSource !== 'CUSTOM_TEXT') {
        await loadOptions(form.paramSource);
      } else {
        currentOptions.value = [];
      }
    }, {
      immediate: true
    });
    /**
     * 提交
     * 校验顺序：
     * 1) guard 防连点
     * 2) 名称 / 编码 / 参数值 内联校验
     * 3) moduleId 异常兜底 toast
     * 4) emit submit，返回 true 才关闭弹窗
     */
    const handleOk = async () => {
      if (submitting.value) return;
      const name = form.paramName.trim();
      const code = form.paramCode.trim();
      const isText = form.paramSource === 'CUSTOM_TEXT';
      errors.paramName = name ? '' : '请填写参数名称';
      errors.paramCode = code ? '' : '请填写参数编码';
      if (isText) {
        errors.paramValue = textValue.value.trim() ? '' : '请填写参数值';
      } else {
        errors.paramValue = multiValue.value.length === 0 ? '请至少选择一项参数值' : '';
      }
      if (errors.paramName || errors.paramCode || errors.paramValue) return;
      // 父层 moduleId 异常（理论上不该出现）→ 用 toast 提示用户刷新
      if (props.moduleId == null) {
        message.error('当前模块异常，请刷新页面后重试');
        return;
      }
      submitting.value = true;
      try {
        var _props$param$id, _props$param2;
        const ok = await props.onSubmit({
          id: (_props$param$id = (_props$param2 = props.param) === null || _props$param2 === void 0 ? void 0 : _props$param2.id) !== null && _props$param$id !== void 0 ? _props$param$id : null,
          moduleId: props.moduleId,
          paramName: name,
          paramCode: code,
          paramSource: form.paramSource,
          paramValueType: isText ? form.paramValueType : 'MULTI_SELECT',
          paramValue: buildPayloadValue(),
          remark: form.remark || ''
        });
        if (ok) emit('update:visible', false);
      } finally {
        submitting.value = false;
      }
    };
    const handleCancel = () => {
      resetOptions();
      emit('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: _unref(open),
        "onUpdate:open": _cache[8] || (_cache[8] = $event => _isRef(open) ? open.value = $event : null),
        title: _unref(isEdit) ? '编辑参数' : '新增参数',
        width: 600,
        "confirm-loading": submitting.value,
        "mask-closable": false,
        "ok-text": "确定",
        "cancel-text": "取消",
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [__props.moduleName || __props.columnName ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(AppstoreOutlined), {
          class: "belong-bar__icon"
        }), _hoisted_2, __props.columnName ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.columnName), 1)) : _createCommentVNode("", true), __props.columnName && __props.moduleName ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/")) : _createCommentVNode("", true), __props.moduleName ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.moduleName), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_a_form, {
          layout: "vertical",
          model: form
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "参数名称",
                required: "",
                "validate-status": errors.paramName ? 'error' : '',
                help: errors.paramName
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: form.paramName,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => form.paramName = $event),
                  placeholder: "请输入参数名称",
                  maxlength: 50,
                  "show-count": "",
                  "allow-clear": ""
                }, null, 8, ["value"])]),
                _: 1
              }, 8, ["validate-status", "help"])]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                required: "",
                "validate-status": errors.paramCode ? 'error' : '',
                help: errors.paramCode
              }, {
                label: _withCtx(() => [_createTextVNode(" 参数编码 "), _hoisted_6]),
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: form.paramCode,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => form.paramCode = $event),
                  disabled: _unref(codeLocked),
                  placeholder: _unref(codeLocked) ? '已锁定' : '请输入英文/数字/下划线',
                  maxlength: 50
                }, null, 8, ["value", "disabled", "placeholder"])]),
                _: 1
              }, 8, ["validate-status", "help"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "参数来源",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: form.paramSource,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => form.paramSource = $event),
                  options: _unref(sourceOptions),
                  placeholder: "请选择参数来源",
                  onChange: onSourceChange
                }, null, 8, ["value", "options"])]),
                _: 1
              })]),
              _: 1
            }), form.paramSource === 'CUSTOM_TEXT' ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "值类型"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                  value: form.paramValueType,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => form.paramValueType = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_radio, {
                    value: "TEXT"
                  }, {
                    default: _withCtx(() => [_createTextVNode("单行")]),
                    _: 1
                  }), _createVNode(_component_a_radio, {
                    value: "LARGE_TEXT"
                  }, {
                    default: _withCtx(() => [_createTextVNode("多行 / 大文本")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "参数值",
            required: "",
            "validate-status": errors.paramValue ? 'error' : '',
            help: errors.paramValue
          }, _createSlots({
            default: _withCtx(() => [form.paramSource === 'CUSTOM_TEXT' && form.paramValueType === 'TEXT' ? (_openBlock(), _createBlock(_component_a_input, {
              key: 0,
              value: textValue.value,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => textValue.value = $event),
              placeholder: "请输入参数值",
              "allow-clear": ""
            }, null, 8, ["value"])) : form.paramSource === 'CUSTOM_TEXT' && form.paramValueType === 'LARGE_TEXT' ? (_openBlock(), _createBlock(_component_a_textarea, {
              key: 1,
              value: textValue.value,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => textValue.value = $event),
              rows: 6,
              placeholder: "请输入参数值（支持多行长文本，例如 prompt 配置）"
            }, null, 8, ["value"])) : (_openBlock(), _createBlock(_component_a_select, {
              key: 2,
              value: _unref(selectValue),
              "onUpdate:value": _cache[6] || (_cache[6] = $event => _isRef(selectValue) ? selectValue.value = $event : null),
              "label-in-value": form.paramSource === 'CONTACTS',
              mode: "multiple",
              options: currentOptions.value,
              "filter-option": form.paramSource === 'CONTACTS' ? false : undefined,
              "not-found-content": _unref(optionsTip) || '未找到人员',
              onSearch: searchContacts,
              onChange: syncSelectedContacts,
              loading: loadingOptions.value,
              placeholder: _unref(multiSelectPlaceholder),
              "show-search": "",
              "option-filter-prop": "label",
              "allow-clear": ""
            }, null, 8, ["value", "label-in-value", "options", "filter-option", "not-found-content", "loading", "placeholder"]))]),
            _: 2
          }, [form.paramSource !== 'CUSTOM_TEXT' ? {
            name: "extra",
            fn: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["options-tip", _unref(optionsTipClass)])
            }, [_unref(optionsTipState) === 'loading' ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "options-tip__icon",
              spin: ""
            })) : _unref(optionsTipState) === 'empty' ? (_openBlock(), _createBlock(_unref(InfoCircleFilled), {
              key: 1,
              class: "options-tip__icon"
            })) : (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
              key: 2,
              class: "options-tip__icon"
            })), _createElementVNode("span", _hoisted_7, [_unref(optionsTipState) === 'count' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(" 共 "), _createElementVNode("b", _hoisted_8, _toDisplayString(currentOptions.value.length), 1), _createTextVNode(" 个候选项 ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString(_unref(optionsTip)), 1)], 64))])], 2)]),
            key: "0"
          } : undefined]), 1032, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: form.remark,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => form.remark = $event),
              placeholder: "可填写参数说明、单位、示例等",
              maxlength: 200,
              "show-count": "",
              "auto-size": {
                minRows: 3,
                maxRows: 6
              },
              "allow-clear": ""
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "title", "confirm-loading"]);
    };
  }
});